/* eslint-disable  max-lines */

/**
 * Google analytics.
 * In all the pages <head> Google analytics js script must be included from Tools Library.
 * example - https://www.philips.com/a1l4rgpa1fx2crzaqh/t1l6vgru59xvprnlz0ll.js
 */
/* This js file contains functions and methods relating to events of Google analytics.
 gaObject parameter being passed is the object structures list which is defined in googleAnalytics.js file
   Note: inside addEventListener functions, remove many if conditions and instead define proper functions to make code more understandable.
   Also note: addEventListener click gets executed two times automatically when user signs-in in website and loads any page.
    this is due to jquery automatically closing navigation div. so put anything inside if statement/function */

const gaObFn = {
  cartitemQtyClass: '.ga_cartitem_qty',
  cartitemPriceClass: '.ga_cartitem_price'
};

gaObFn.getMetaByName = (metaName) => {
  let metaByName = '';

  if (document.querySelector(`meta[name="${metaName}"]`)) {
    metaByName = document.querySelector(`meta[name="${metaName}"]`).content;
  }

  return metaByName;
};

/**
 * @description - function to extract the product informations of addto cart clicked.
 * @param {object} clickedProductInfo - specific informations of the product which added to cart
 * @param {object} element - form element of the add to cart
 * @returns {object} returns product info for which added to cart clicked
 * @example addToCartData([],[]);
 */
gaObFn.getAddToCartData = (clickedProductInfo, element) => {
  const productCodeClassName = 'ph-pdpproduct-code',
      priceSpan = 'ph-price > span';

  if (element.querySelector('.ph-freqorderedproduct__jcarousel')) {
    clickedProductInfo.listName = 'recommended-products';

    if (element.closest('.prod_list').querySelector(`.${priceSpan}`)) {
      clickedProductInfo.productPrice = String(element.closest('.prod_list')
        .querySelector(`.${priceSpan}`).textContent).replace(/[^0-9.]/g, '');
    }
  }

  if (element.querySelector('.ph-recentlyviewed-products__jcarousel')) {
    clickedProductInfo.listName = 'recently-viewed';

    if (element.closest('.ph-card-item').querySelector('.ph-recently-product-price')) {
      clickedProductInfo.productPrice = String(element.closest('.ph-card-item')
        .querySelector('.ph-recently-product-price').textContent).replace(/[^0-9.]/g, '');
    }
  }

  if (element.querySelector(`.${productCodeClassName}`)) {
    clickedProductInfo.listName = 'product-detail';
    clickedProductInfo.productId = element.querySelector(`.${productCodeClassName}`).value;
    clickedProductInfo.productQuantity = parseInt(element.querySelector('.ph-pdp_qty').value, 10);

    if (element.closest('.ph-pdp_priceaddtocart_main').querySelector('.ph-pdp_strike_finalprice')) {
      clickedProductInfo.productPrice = String(element.closest('.ph-pdp_priceaddtocart_main')
        .querySelector('.ph-pdp_strike_finalprice').textContent).replace(/[^0-9.]/g, '');
    } else {
      clickedProductInfo.productPrice = String(gaObFn.getMetaByName('PHILIPS.METRICS.PRICE')).replace(/[^0-9.]/g, '');
    }
  } else {
    clickedProductInfo.productId = element.querySelector('.productcode-postable').value;
    clickedProductInfo.productQuantity = parseInt(element.querySelector('.qty').value, 10);

    if (element.closest('.ph-decisionpage__card').querySelector(`.${priceSpan}`)) {
      clickedProductInfo.productPrice = String(element.closest('.ph-decisionpage__card')
        .querySelector(`.${priceSpan}`).textContent).replace(/[^0-9.]/g, '');
    }
  }

  return clickedProductInfo;
};

/**
 * @description - function to extract the product informations of addto cart clicked from MyList.
 * @param {object} productsDiv - div element of products for which add to cart was clicked
 * @returns {object} returns product info for which added to cart clicked
 * @example addToCartData([],[]);
 */
gaObFn.getProductDetailsMyList = (productsDiv) => {
  const productsList = productsDiv.querySelector('#myshoppinglistDetails').children,
      productsListArray = [...productsList],
      productsLocalArray = [];

  productsListArray.forEach((element) => {
    const configInfo = element.querySelectorAll('li'),
        configInfoArray = [...configInfo],
        configOptionsMylist = [];

    configInfoArray.forEach((elementConfig) => {
      configOptionsMylist.push(elementConfig.textContent.replace('+', '').trim());
    });

    const currentProduct = {
      id: element.querySelector('.ph-favproduct_ctn').getAttribute('data-ctn'),
      quantity: element.querySelector('.ph-favqty').value,
      locale: window.eddlContext.locale.code,
      configValue: configOptionsMylist
    };

    if (currentProduct.quantity > 0) {
      productsLocalArray.push(currentProduct);
    }
  });

  return productsLocalArray;
};

gaObFn.myListAddtoCart = (gaObject) => {
  if (document.querySelector('.ph-addshoppinglisttocart')) {
    let eddlAction = {};

    document.querySelectorAll('.ph-addshoppinglisttocart').forEach((mylistItem) => {
      mylistItem.addEventListener('click', (event) => {
        window.eddlEvents = window.eddlEvents || [];

        const finalProductsArray = gaObFn.getProductDetailsMyList(event.target.closest('.ph-panel-body')),
            productInfo = {
              listName: 'cartItems',
              locale: window.eddlContext.locale,
              productsArray: finalProductsArray
            };

        eddlAction = gaObject.addToCartEvent(productInfo);
        window.eddlEvents.push(eddlAction);
      });
    });
  }
};

gaObFn.productDetailPageView = (gaObject, pageData) => {
  if (document.querySelectorAll('.ph-page-productDetails').length > 0) {
    let eddlAction = {};

    pageData.productId = String(gaObFn.getMetaByName('PHILIPS.METRICS.PRODUCTID'));

    if (document.querySelectorAll('.ph-pdpproduct-code')[0]) {
      pageData.productId = String(document.querySelectorAll('.ph-pdpproduct-code')[0].value);
    }

    pageData.productPrice = String(gaObFn.getMetaByName('PHILIPS.METRICS.PRICE')).replace(/[^0-9.]/g, '');
    pageData.productStock = 0;
    // We may get product stock info based on certain criteria, for now considering as 0.

    const productsArray = [],
        productObject = {
          id: pageData.productId,
          locale: pageData.locale.code,
          displayTypes: []
        };

    if (pageData.productPrice > 0) {
      productObject.price = pageData.productPrice;
    }

    if (pageData.productStock > 0) {
      productObject.stock = pageData.productStock;
    }

    productsArray.push(productObject);
    eddlAction = gaObject.productDetailsPage(pageData.locale.currency, productsArray);

    window.prodDetail = {};
    window.eddlEvents = window.eddlEvents || [];

    if (pageData.productPrice === '') {
      window.prodDetail[pageData.productId] = eddlAction;
    } else {
      window.eddlEvents.push(eddlAction);
    }
  }
};

gaObFn.productDetailAddToFav = (gaObject, pageData) => {
  if (document.querySelectorAll('.ph-page-productDetails').length > 0) {
    let eddlAction = {};

    pageData.productId = String(gaObFn.getMetaByName('PHILIPS.METRICS.PRODUCTID'));

    if (document.querySelectorAll('.ph-pdpproduct-code')[0]) {
      pageData.productId = String(document.querySelectorAll('.ph-pdpproduct-code')[0].value);
    }

    pageData.productPrice = String(gaObFn.getMetaByName('PHILIPS.METRICS.PRICE')).replace(/[^0-9.]/g, '');
    pageData.productStock = 0;
    // We may get product stock info based on certain criteria, for now considering as 0.

    const productsArray = [],
        productObject = {
          id: pageData.productId,
          locale: pageData.locale.code
        };

    if (pageData.productPrice > 0) {
      productObject.price = pageData.productPrice;
    }

    if (pageData.productStock > 0) {
      productObject.stock = pageData.productStock;
    }

    productObject.quantity = document.querySelector('.ph-pdp_qty').value;
    productsArray.push(productObject);
    eddlAction = gaObject.productDetailsAddToFav(pageData.locale.currency, productsArray);
    window.eddlEvents = window.eddlEvents || [];
    window.eddlEvents.push(eddlAction);
  }
};

gaObFn.cartConfiguredProductData = (cartItem) => {
  const configuredProductData = [];

  if (cartItem.querySelectorAll('.ph-cartPage__productConfigurationList').length > 0) {
    cartItem.querySelectorAll('.ph-cartPage__productConfigurationList').forEach((singleProductData) => {
      singleProductData.querySelectorAll('.ph-cartPage__productConfigurationSubDetails').forEach((productDetails) => {
        configuredProductData.push(productDetails.textContent.trim());
      });
    });
  }

  return configuredProductData;
};

gaObFn.cartProductIteration = () => {
  const productionArray = [];

  document.querySelectorAll('.ga_cartitems').forEach((cartItem) => {
    const productObject = {
      id: cartItem.querySelector('.ga_cartitem_code').textContent,
      locale: window.eddlContext.locale.code,
      quantity: parseInt(cartItem.querySelector(gaObFn.cartitemQtyClass).textContent, 10),
      price: gaObFn.checkFloatValue(cartItem.querySelector(gaObFn.cartitemPriceClass).textContent)
    };

    const cartConfiguredProductDetails = gaObFn.cartConfiguredProductData(cartItem);

    if (cartConfiguredProductDetails.length !== 0) {
      productObject.config = cartConfiguredProductDetails;
    }

    productionArray.push(productObject);
  });

  return productionArray;
};

gaObFn.checkFloatValue = (inputValue) => {
  if (isNaN(parseFloat(inputValue))) {
    return 0;
  }

  return parseFloat(inputValue);
};

gaObFn.cartPageView = (gaObject) => {
  if (document.querySelectorAll('.ga_cartpage').length > 0) {
    setTimeout(() => {
      const productsArray = gaObFn.cartProductIteration();
      let eddlAction = {};

      eddlAction = gaObject.gaCartView(productsArray);
      window.eddlEvents = window.eddlEvents || [];
      window.eddlEvents.push(eddlAction);
    }, 100);
  }
};

gaObFn.stepCheckoutPage = (gaObject) => {
  if (document.querySelectorAll('.ga_checkout').length > 0) {
    setTimeout(() => {
      const productsArray = gaObFn.cartProductIteration(),
          gaStep = document.querySelector('.ga_page_step').textContent;
      let eddlAction = {};

      eddlAction = gaObject.checkoutStep(gaStep, productsArray);
      window.eddlEvents = window.eddlEvents || [];
      window.eddlEvents.push(eddlAction);
    }, 100);
  }
};

gaObFn.orderItemsIterator = (itemClassName, itemArray) => {
  const multipleContainers = document.querySelectorAll(itemClassName),
      containerArray = [...multipleContainers];

  containerArray.forEach((singleItem) => {
    itemArray.push(singleItem.textContent);
  });

  return itemArray.toString();
};

gaObFn.handleStockValue = (orderItem) => {
  const stockValue = orderItem.querySelector('.ph-atpPerLineItem__stock').textContent.trim();

  if (stockValue === '') {
    return '';
  } else if (stockValue === 'null' || stockValue === null) {
    return 'NA';
  }

  return parseInt(stockValue, 10);
};

gaObFn.orderConfirmationPageEvent = (gaObject) => {
  const shipToNumber = [],
      salesOrg = [],
      option = [],
      billTo = [],
      payTo = [],
      soldTo = [];

  if (document.querySelectorAll('.ga_orderconfirmation').length > 0) {
    setTimeout(() => {
      const productsArray = [],
          purchaseInfo = {
            orderId: document.querySelector('.ph-orderId').value,
            revenue: gaObFn.checkFloatValue(document.querySelector('.ph-orderValue').value),
            tax: gaObFn.checkFloatValue(document.querySelector('.ph-orderTax').value),
            shipping: gaObFn.checkFloatValue(document.querySelector('.ph-orderShipping').value),
            discount: document.querySelector('.ph-orderDiscount').value,
            currency: document.querySelector('.ph-currency').value,
            salesTracking: document.querySelector('.ph-salesTracking').value,
            shipTo: gaObFn.orderItemsIterator('.ph-shiptoNumber', shipToNumber),
            coupon: '',
            paymentCardType: document.querySelector('.ph-paymentCardType').value,
            option: gaObFn.orderItemsIterator('.ph-deliveryPreference__option', option),
            salesOrg: gaObFn.orderItemsIterator('.ph-salesOrg', salesOrg),
            billTo: gaObFn.orderItemsIterator('.ph-billToNumber', billTo),
            payTo: gaObFn.orderItemsIterator('.ph-payToNumber', payTo),
            soldTo: gaObFn.orderItemsIterator('.ph-soldToNumber', soldTo),
            userId: document.querySelector('.ph-customerId__userId').textContent.trim()
          };

      let eddlAction = {};

      document.querySelectorAll('.ga_orderitems').forEach((orderItem) => {
        const productObject = {
          id: orderItem.querySelector('.ga_orderitem_code').textContent,
          locale: window.eddlContext.locale.code,
          quantity: parseInt(orderItem.querySelector('.ga_orderitem_qty').textContent, 10),
          price: gaObFn.checkFloatValue(orderItem.querySelector('.ga_orderitem_price').textContent),
          coupon: '',
          stock: gaObFn.handleStockValue(orderItem)
        };

        productsArray.push(productObject);
      });

      let recentOrderId = '';

      window.eddlEvents = window.eddlEvents || [];

      if (typeof Storage !== 'undefined' && sessionStorage.getItem('_recentOrderId')) {
        recentOrderId = sessionStorage.getItem('_recentOrderId');
      }

      if (recentOrderId !== purchaseInfo.orderId) {
        eddlAction = gaObject.gaOrderConfirmation(purchaseInfo, productsArray);
        window.eddlEvents.push(eddlAction);

        if (typeof Storage !== 'undefined') {
          sessionStorage.setItem('_recentOrderId', purchaseInfo.orderId);
        }
      }
    }, 100);
  }
};

gaObFn.getProductDetailsCartPage = (prodid) => {
  const gaproductclass = `#ga_cartitems_${prodid}`,
      {locale} = window.eddlContext,
      gaproductdetails = document.querySelector(gaproductclass);

  const product = {
    productId: gaproductdetails.querySelector('.ga_cartitem_code').textContent,
    locale,
    productQuantity: parseInt(gaproductdetails.querySelector(gaObFn.cartitemQtyClass).textContent, 10)
  };

  if (document.querySelector('.ga_isanonymous').textContent !== 'true' && gaproductdetails.querySelector(gaObFn.cartitemPriceClass).textContent) {
    product.productPrice = parseFloat(gaproductdetails.querySelector(gaObFn.cartitemPriceClass).textContent);
  }

  return product;
};

gaObFn.cartPageUpdateQuantity = (gaObject) => {
  if (document.querySelector('.ph-qtydet__block__action--save')) {
    document.addEventListener('click', (eventFired) => {
      if (eventFired.target.classList.contains('ph-qtydet__block__action--save')) {
        window.eddlEvents = window.eddlEvents || [];

        const modifiedQuantity = parseInt(eventFired.target.parentElement.parentElement.querySelector('.quantity').value, 10),
            prodid = eventFired.target.id.split('_'),
            gaproductdetails = document.querySelector(`#ga_cartitems_${prodid[1]}`),
            currentQuantity = parseInt(gaproductdetails.querySelector(gaObFn.cartitemQtyClass).textContent, 10);

        if (currentQuantity !== modifiedQuantity && modifiedQuantity > 0) {
          const productInfo = gaObFn.getProductDetailsCartPage(prodid[1]);
          let eddlAction = {};

          productInfo.listName = 'cartItems';
          productInfo.productQuantity = modifiedQuantity;
          eddlAction = gaObject.addToCartEvent(productInfo);
          window.eddlEvents.push(eddlAction);
        } else if (modifiedQuantity === 0) {
          ACC.cartremoveitem.trackDeleteGoogleAnalytics(prodid[1]);
        }
      }
    });
  }
};

gaObFn.stepOptionShippingPage = (gaObject) => {
  if (document.querySelector('.ph-shipping__procceed')) {
    window.tempEvent = window.tempEvent || [];

    const gaStep = 'delivery';
    let gaOption = '',
        eddlAction = {};

    if (document.querySelector('input[name="delivery"]:checked')) {
      // Current store is normal store
      gaOption = document.querySelector('input[name="delivery"]:checked').parentElement.textContent.trim();
      eddlAction = gaObject.checkoutStepOption(gaStep, gaOption);
      window.tempEvent.push(eddlAction);
    } else {
      // Current store is onestore
      const salesAreaSections = document.querySelectorAll('.ph-onestore_b2bsections');

      salesAreaSections.forEach((element) => {
        const salesorg = element.attributes.salesorg.value,
            deliveryOptionChecked = `input[name="delivery_${salesorg}"]:checked`;

        gaOption = `${salesorg}_${document.querySelector(deliveryOptionChecked).parentElement.textContent.trim()}`;

        eddlAction = gaObject.checkoutStepOption(gaStep, gaOption);
        window.tempEvent.push(eddlAction);
      });
    }
  }
};

gaObFn.stepOptionPaymentPage = (gaObject) => {
  if (document.querySelector('.ga_orderconfirmation')) {
    window.eddlEvents = window.eddlEvents || [];

    const gaStep = 'payment';
    let gaOption = '',
        eddlAction = {};

    gaOption = document.querySelector('.ph-orderPaymentType').value;

    if (document.querySelector('.ph-paymentInfo')) {
      gaOption = document.querySelector('.ph-paymentInfo').value;
    }

    eddlAction = gaObject.checkoutStepOption(gaStep, gaOption);
    window.eddlEvents.push(eddlAction);
  }
};

gaObFn.chatButtonTrack = (gaObject) => {
  document.querySelector('.chatButtonClass').addEventListener('click', () => {
    window.eddlEvents = window.eddlEvents || [];

    let eddlAction = {};
    const {pageName} = window.eddlContext.page;

    const clickEventInfo = {
      triggerName: 'button:chat',
      eventValue: 'generic events',
      componentType: 'button',
      interaction: {
        goal: 'button:chat',
        description: `${pageName}:interaction:button:chat`,
        interactive: true
      }
    };

    eddlAction = gaObject.interactionEvent(clickEventInfo);
    window.eddlEvents.push(eddlAction);
  });
};

((gaObject) => {
  const pageData = {
        locale: window.eddlContext.locale,
        page: window.eddlContext.page
      },
      formClassName = 'add_to_cart_form';

  document.addEventListener('submit', (eventFired) => {
    if (eventFired.target && eventFired.target.closest(`.${formClassName}`)) {
      window.eddlEvents = window.eddlEvents || [];

      const clickedProductInfo = pageData;

      clickedProductInfo.productPrice = '';
      clickedProductInfo.listName = 'product-list';

      const productInfo = gaObFn.getAddToCartData(clickedProductInfo, eventFired.target.closest(`.${formClassName}`));
      let eddlAction = {};

      productInfo.productPrice = gaObFn.checkFloatValue(productInfo.productPrice);

      eddlAction = gaObject.addToCartEvent(productInfo);

      window.eddlEvents.push(eddlAction);
    }
  });

  document.addEventListener('click', (eventFired) => {
    if (document.querySelectorAll('.ph-page-orders').length > 0) {
      window.gaclkFn.ordersInteractionEventsClicks(eventFired.target);
    }

    if ((eventFired.target.classList.contains('ph-decisionpageconfigbutton') ||
                eventFired.target.classList.contains('ph-pdpconfigbutton')) &&
                eventFired.target.closest(`.${formClassName}`)) {
      window.configPro = {};

      const clickedProductInfo = pageData;

      clickedProductInfo.productPrice = '';
      clickedProductInfo.listName = 'product-list';

      const configProductInfo = gaObFn.getAddToCartData(clickedProductInfo, eventFired.target.closest(`.${formClassName}`));

      configProductInfo.productPrice = gaObFn.checkFloatValue(configProductInfo.productPrice);

      window.configPro[configProductInfo.productId] = configProductInfo;
    }

    if (eventFired.target.classList.contains('ph-popupconfig_applybtn')) {
      window.eddlEvents = window.eddlEvents || [];

      const productId = document.querySelector('#currentProductCode').value;
      let eddlAction = {};

      if (document.querySelectorAll('.ph-cartPage').length === 0 && window.configPro[productId]) {
        eddlAction = gaObject.addToCartEvent(window.configPro[productId]);
        window.eddlEvents.push(eddlAction);
      }
    }
  });

  document.addEventListener('click', (eventFired) => {
    if (document.querySelectorAll('.ph-page-productDetails').length > 0 && eventFired.target.classList.contains('ph-savetolistBtn')) {
      gaObFn.productDetailAddToFav(gaObject, pageData);
    }
  });

  document.addEventListener('click', (eventFired) => {
    if (eventFired.target.classList.contains('ph-share-continue') && document.querySelectorAll('.ph-page-cartPage').length > 0) {
      const productsArray = gaObFn.cartProductIteration();
      let eddlAction = {},
          opportunityIdValue = false;

      if ($('#cboxContent .ph-oppId').length > 0 && $('#cboxContent .ph-oppId').val()) {
        opportunityIdValue = true;
      }

      eddlAction = gaObject.gaCartShareCopyLink(productsArray, opportunityIdValue);
      window.eddlEvents = window.eddlEvents || [];
      window.eddlEvents.push(eddlAction);
    }
  });

  document.addEventListener('click', (eventFired) => {
    if (eventFired.target.classList.contains('ph-cart-savetolistBtn') && document.querySelectorAll('.ph-page-cartPage').length > 0) {
      setTimeout(() => {
        const productsArray = gaObFn.cartProductIteration();
        let eddlAction = {};

        eddlAction = gaObject.gaCartFavView(productsArray);
        window.eddlEvents = window.eddlEvents || [];
        window.eddlEvents.push(eddlAction);
      }, 100);
    }
  });

  document.addEventListener('click', (eventFired) => {
    if (document.querySelectorAll('.ph-page-search').length > 0 ||
        document.querySelectorAll('.ph-page-productList').length > 0) {
      if (eventFired.target.classList.contains('ph-addtoshoppinglist-link') ||
          eventFired.target.classList.contains('ph-icon-heart-bordered')) {
        window.configPro = {};

        const clickedProductInfo = pageData;

        clickedProductInfo.productPrice = '';
        clickedProductInfo.listName = 'product-list';

        const configProductInfo = gaObFn.getAddToCartData(clickedProductInfo, eventFired.target.closest(`.${formClassName}`));

        configProductInfo.productPrice = gaObFn.checkFloatValue(configProductInfo.productPrice);

        window.configPro[configProductInfo.productId] = configProductInfo;
      }

      if (eventFired.target.classList.contains('ph-savetolistBtn')) {
        window.eddlEvents = window.eddlEvents || [];

        const productId = eventFired.target.getAttribute('data-productcode');

        let eddlAction = {};

        eddlAction = gaObject.addToFavoritePlp(window.configPro[productId]);

        window.eddlEvents.push(eddlAction);
      }
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    gaObFn.myListAddtoCart(gaObject);
    gaObFn.productDetailPageView(gaObject, pageData);
    gaObFn.cartPageView(gaObject);
    gaObFn.stepCheckoutPage(gaObject);
    gaObFn.orderConfirmationPageEvent(gaObject);
    gaObFn.cartPageUpdateQuantity(gaObject);
    gaObFn.stepOptionShippingPage(gaObject);
    gaObFn.stepOptionPaymentPage(gaObject);

    if (document.querySelectorAll('.chatButtonClass').length > 0) {
      gaObFn.chatButtonTrack(gaObject);
    }
  });
})(window.gaObject);
/* eslint-enable  max-lines */
